<script lang="ts">
    import { apiBaseURL as apiBaseURL_conf } from "../config"
    import Col from "./Col.svelte"

    export let row: Row
    export let contentId: string
    export let apiBaseURL: string = apiBaseURL_conf
</script>

<section class="wrapper {row.full ? 'full' : ''}">
    {#each row.cols as col, i}
        <Col row="{row}" col="{col}" index="{i}" contentId="{contentId}" apiBaseURL="{apiBaseURL}" />
    {/each}
</section>
